import { RoleModel } from '@core/services/api.service';

export class LoadRolesAction {
  static readonly type = '[Roles] Load Roles';
}

export class LoadRolesSuccessAction {
  static readonly type = '[Roles] Load Roles Success';

  constructor(public payload: { roles: RoleModel[] }) { }
}

export class LoadRolesFailAction {
  static readonly type = '[Roles] Load Roles Fail';
}
